import babelPolyfill from 'babel-polyfill'
import Vue from 'vue'
import axios from 'axios'
import vueTouch from 'vue-touch'
import {
  getRunningEnv
} from './frontend-lib/tools/getPlatform'
import APIS from './apis'
import qs from 'qs'
import entry from './frontend-lib/component/vue/entry'
Vue.use(entry)

try {
  window.catchVueErrorFromHeadScript(Vue)
} catch (e) {
  console.log('--- window.catchVueErrorFromHeadScript --- catch e', e)
}

import {
  getUrlParams
} from './frontend-lib/tools/url'
Vue.use(vueTouch)
// router
import router from './router/index.js'
// 移动端适配
import 'lib-flexible'
// store
import store from './store/store.js'
// lazyload
import VueLazyload from 'vue-lazyload'
//Vue.use(VueLazyload)

Vue.use(VueLazyload, {
  loading: require('../static/bg_base.gif'),
})
// set wechat title
import '@/lib/v-title'
// Vue.use(VueWechatTitle)

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

let options = {
  fullscreenEl: false
}
Vue.use(preview, options)


// 引用全局mixin
import gMixin from './mixins/globalMixin'
Vue.mixin(gMixin)

/*全局公用组件注册*/
Vue.component('sort-div', {
  render: function (createElement) {
    return createElement('div', Object.keys(this.$slots).sort((a, b) => a - b).map(i => {
      return this.$slots[+i]
    }))
  }
})

// 将一些首屏无关的脚本改造为异步加载
import './async-hack'

// 埋点统计的Class
import {
  TRACKER
} from './lib/zhugeTrack'
// 配置TRACKER，用于触发埋点的对象
let trackerObj = new TRACKER()
var isDouyinApp = navigator.userAgent.toLowerCase().includes('toutiaomicroapp')
import { loadScript } from '@/lib/units'
//抖音端隐藏诸葛io
if (isDouyinApp) {
  loadScript('https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js')
  // 抖音端加载抖音sdk
  Object.getOwnPropertyNames(trackerObj.__proto__).map(key => {
    if (typeof trackerObj[key] === 'function') {
      trackerObj[key] = function () {}
    }
  })
}
window.TRACKER = trackerObj

// 新埋点规范
import CpStat from './lib/track'
Vue.prototype.$cpStat = CpStat

// 配置 axios
Vue.prototype.$http = axios
// Vue.prototype.$stat = new stat()
Vue.prototype.$env = getRunningEnv()

axios.defaults.withCredentials = true
/* 为网络错误提供统一中间件处理 */
axios.defaults.validateStatus = status => {
  return true
}

function getHashParameters() {
  var arr = (location.hash || "").replace(/^\#/, '').split("&");
  var params = {};
  for (var i = 0; i < arr.length; i++) {
    var data = arr[i].split("=");
    if (data.length == 2) {
      params[data[0]] = data[1];
    }
  }
  var channelIdObj
  Object.keys(params).map((item, index) => {
    if (item.indexOf('?')) {
      let getChannelId = item.split("?")[1]
      if (getChannelId == 'channelId') {
        channelIdObj = {
          channelId: params[item]
        }
      }
    }
  })
  params = Object.assign(params, channelIdObj)
  return params;
}

axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true
axios.interceptors.request.use(function (config) {
  //配合后端解决新版微信授权问题，统一加上token
  if (localStorage.getItem('cp_token')) {
   config.headers.cpToken = localStorage.getItem('cp_token')
  }
  let getPostChannelId = () => {
    if (config.data) {
      let params = qs.parse(config.data)
      return params.channelId
    } else {
      return ''
    }
  }
  var channelId = getHashParameters().channelId || config.params.channelId || getPostChannelId()
  config.url = channelId ? changeApiHost(channelId, config.url) : config.url
  return config
}, function (error) {
  // 对请求失败做处理
  return Promise.reject(error)
})

axios.interceptors.response.use(
  res => {
    if (res.status && res.status != 200) {
      window.monitor.stat({
        level: 'error',
        error: 'API',
        url: res.config.url,
        status: res.status,
        msg: res.stack
      })
    }

    return res
  },
  err => {
    window.monitor.stat({
      level: 'error',
      error: 'API',
      url: err.config.url,
      msg: err.stack
    })

    return err
  }
)

// 神策埋点
import { trackPlugin } from '@yxl/libs'

Vue.use(trackPlugin, {
  trackOptions: {
    customTrackConfig: {
      is_track_single_page: false
    }
  }
})


/*xstream扩展*/
import * as xstream from 'xstream'

window.xstream = xstream
importOutdatedLib()

function importOutdatedLib() {
  require('./lib/xstream.extra')
  var Stream = xstream.Stream
  Stream.fromEvent = function (el, event) {
    return Stream.create({
      start(prod) {
        var n = 1

        this.listener = function (e) {
          prod.next({
            event: e,
            index: n++
          })
        }

        el.addEventListener(event, this.listener)
      },
      stop() {
        el.removeEventListener(event, this.listener)
      }
    })
  }

  Stream.ajax = function (url, params, method) {
    return Stream.create({
      start(prod) {
        axios[method || 'get'](url, method == 'post' ? params : {
          params
        }).then(res => {
          if (+res.data.code !== 1) {
            window.monitor.stat({
              level: 'error',
              error: 'API',
              url: url,
              status: res.data.code,
              params: JSON.stringify(params?params:{}),
              msg: JSON.stringify(res.data)
            })
            return Promise.reject(res.data)
          }
          return res.data
        }).then(json => {
          prod.next(json)
          prod.complete()
        }, err => prod.error(err))
      },
      stop() {}
    })
  }

  Stream.domReady = function () {
    return Stream.from(domReadyPr)
  }

  Stream.prototype.$addListener = function (vm, listeners) {
    if (!(vm instanceof Vue)) {
      throw new Error('vm不是Vue实例')
    }
    vm._stream_.push([this, listeners])
    return this.addListener(listeners)
  }
}

setTimeout(installFunction)

function installFunction() {
  // 连击页面任意位置10次，开启开发模式
  xstream.Stream.fromEvent(document.documentElement, 'touchstart')
    .warpGroup(300, 20)
    .filter(res => res.length >= 100)
    .take(1)
    .addListener({
      next() {
        alert(__PUBLISH_HASH__)
      }
    })
}

function getApiHost(getUrl,type) {
  let hostList = getUrl.split('/')
  let host = hostList[2]
  //小程序的接口路径切换成p-
  if (type) {
    if (host.includes(`lingxi${APIS.env}.xinli001.com`) || host.includes(`m-lingxi${APIS.env}.xinli001.com`)) {
      hostList[2] = `p-lingxi${APIS.env}.xinli001.com`
    }
    if (host.includes(`cpapi${APIS.env}.xinli001.com`) || host.includes(`m-cpapi${APIS.env}.xinli001.com`)) {
      hostList[2] = `p-cpapi${APIS.env}.xinli001.com`
    }
  }else{
    if (host.includes(`m-lingxi${APIS.env}.xinli001.com`)) {
      hostList[2] = `lingxi${APIS.env}.xinli001.com`
    }
    if (host.includes(`m-cpapi${APIS.env}.xinli001.com`)) {
      hostList[2] = `cpapi${APIS.env}.xinli001.com`
    }
  }
  var newUrl = ''
  hostList.map((items, index) => {
    newUrl = newUrl + '/' + items
  })
  return newUrl.substr(1)
}

function changeApiHost(channelId, url) {
  let getUrl = url
  let type = ''
  let getChannelId = channelId.toString()
  //研测环境不需要m- p-
  if (APIS.env) {
    return getApiHost(getUrl)
  }
  let isOldHost = ['122','168','238','364','378','394','398','485','1396','1409','1542','1785','1787','1843','1908','2044','2068','2147','2190','2244','2290','2291','2432',].includes(getChannelId)
  // 头条渠道 或者 快手渠道 用p-路由
  let isTouTiaoHost = ['2345', '2545','2939', '3268'].includes(getChannelId)
  if (isTouTiaoHost) {
    type = 'OTHER_WEB_APP'
  }
  let apiUrl = (isOldHost || isTouTiaoHost)?getApiHost(getUrl, type):getUrl
  return apiUrl
}

//调试工具，链接上加vconsole=1可见
if (location.href.indexOf('vconsole=1') !== -1) {
  // 劫持console.log，存储vconsole加载前的打印数据
  let consoleLog = []
  let myVconsole = null
  const logMethod = console.log
  console.log = function() {
    if (!myVconsole) {
      consoleLog.push(arguments);
    }
    logMethod.apply(console, arguments);
  }
  const vconsoleUrl = 'https://unpkg.com/vconsole/dist/vconsole.min.js'
  loadScript(vconsoleUrl, function() {
    myVconsole = new window.VConsole()
    let i = 0,
        len = consoleLog.length
    for (; i < len; i++) {
      const item = consoleLog[i]
      console.log.apply(console, item)
    }
  })
}

import index from './App'
const App = new Vue({
  store,
  router,
  template: '<index></index>',
  components: {
    index
  },
  created() {
    document.getElementById('pageLoading').remove()
  }
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js